module.exports = __webpack_public_path__ + "static/media/seleccion-navidad.c2bbe5db.jpg";